import React from 'react';
import LinkedIn from '../../assets/imgs/socialMedia/linkedIn-white.svg';

const formatName = (name) => {
  return name.replace('Alexis Lo', 'Alexis\u00A0Lo');
};

const ItemCard = ({ name, position, photo, link = true, classes = '' }) => {
  return (
    <div className={`relative rounded-lg shadow-md text-center p-5  bg-white-50 flex flex-col items-center ${classes}`}
      style={{ minHeight: '400px' }}
    >
      <img src={photo} alt="picture" className="rounded-full w-56 h-auto" />

      <div className="h-[58px] flex items-start justify-center w-full my-3">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl text-blue-700 font-bold text-center break-words">
            {formatName(name)}
          </h2>
        </div>
      </div>

      <div className="relative flex flex-col items-center justify-between h-[120px] md:h-[90px] lg:h-[114px]">
        <div className="flex items-start justify-center w-full">
          <p className="text-dark-grey-700 font-light text-center break-words">
            {position}
          </p>
        </div>

        <div className="flex flex-col items-center">
          <hr className="w-11 border-blue-700 border-t-2 mb-3" />
          <a href={link} target="_blank" rel="noreferrer">
            <img src={LinkedIn} className="w-8 rounded-lg p-2 bg-blue-700 hover:bg-blue-800 transition-colors duration-200" alt={name} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;